import { demoDomain } from "./demoDomain";

export const demoSiteOrigin = `https://${demoDomain}`;
